import React, { useState } from "react";
import cx from "classnames";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Nav,
  Col,
  Row,
  Button,
  NavItem,
  DropdownItem
} from "reactstrap";

import Ionicon from "react-ionicons/lib/MdGrid";

import bg4 from "../../../../assets/utils/images/dropdown-header/abstract4.jpg";

import { closeAlert, fireHtmlContainer, fireSuccessAlert } from "../../Alerts/sweet";
import { handleApiErrors } from "../../Alerts/errors";
import ShortcutsSettings from "./Components/ShortcutsSettings";

import * as userActions from "../../../../reducers/UserOptions";
import api from "../../../../api";


const Redirects = ({menuItems, menuItemsShortcuts, setMenuItemsShortcuts}) => {

  const handleConfigShortcuts = async () => {
    const _handleSubmit = async (newMenuItemsShortcuts) => {
      try {
         closeAlert();

         const { data } = await api.put(`/users/v1/changeMenuItemsShortcuts`, { menuItemsShortcuts: newMenuItemsShortcuts });

         await fireSuccessAlert(`Scurtaturile au fost actualizate.`)

         setMenuItemsShortcuts(newMenuItemsShortcuts);
      } catch (error) {
        handleApiErrors(error);
      }
    }

    await fireHtmlContainer(`CONFIGUREAZA OPTIUNI RAPIDE`, <ShortcutsSettings menuItems={menuItems} menuItemsShortcuts={menuItemsShortcuts} onSubmit={_handleSubmit} />, { width: "90%"})
  }

  return (
    <React.Fragment>
      <UncontrolledDropdown>
        <DropdownToggle className="p-0 mr-2" color="link">
          <div className="icon-wrapper icon-wrapper-alt rounded-circle">
            <div
              className="icon-wrapper-bg bg-danger d-flex justify-content-center"
              style={{ alignItems: "center" }}
            >
              <Ionicon beat={false} color="#d92550" fontSize="35px" />
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu right className="dropdown-menu-xl rm-pointers">
          <div className="dropdown-menu-header">
            <div className="dropdown-menu-header-inner bg-plum-plate">
              <div
                className="menu-header-image"
                style={{
                  backgroundImage: "url(" + bg4 + ")"
                }}
              />
              <div className="menu-header-content text-white">
                <h5 className="menu-header-title">Navigare rapida</h5>
                {/* <h6 className="menu-header-subtitle">
                  Easy grid navigation inside dropdowns
                </h6> */}
              </div>
            </div>
          </div>
          <div className="grid-menu grid-menu-xl grid-menu-3col">
            <Row className="no-gutters">
              {menuItemsShortcuts.map((_,index) => {
                const _to = _["to"].split("#")[1];

                return ( <Col xl="4" sm="6" key={index}>
                <Link to={_to}>
                  <Button
                    className="btn-icon-vertical btn-square btn-transition"
                    outline
                    color="link"
                  >
                    <i className={cx("icon-gradient bg-night-fade btn-icon-wrapper btn-icon-lg mb-3", _["icon"])}>
                      {" "}
                    </i>
                    {_["label"]}
                  </Button>
                </Link>
              </Col>)
              })}
              {/* <Col xl="4" sm="6">
                <Link to="/commands/createCommand">
                  <Button
                    className="btn-icon-vertical btn-square btn-transition"
                    outline
                    color="link"
                  >
                    <i className="pe-7s-display1 icon-gradient bg-night-fade btn-icon-wrapper btn-icon-lg mb-3">
                      {" "}
                    </i>
                    Adaugare comanda
                  </Button>
                </Link>
              </Col>
              <Col xl="4" sm="6">
                <Link to="/invoices/overview">
                  <Button
                    className="btn-icon-vertical btn-square btn-transition"
                    outline
                    color="link"
                  >
                    <i className="pe-7s-notebook icon-gradient bg-night-fade btn-icon-wrapper btn-icon-lg mb-3">
                      {" "}
                    </i>
                    Facturi
                  </Button>
                </Link>
              </Col>
              <Col xl="4" sm="6">
                <Link to="/commands/overview">
                  <Button
                    className="btn-icon-vertical btn-square btn-transition"
                    outline
                    color="link"
                  >
                    <i className="pe-7s-hourglass icon-gradient bg-night-fade btn-icon-wrapper btn-icon-lg mb-3">
                      {" "}
                    </i>
                    Comenzi
                  </Button>
                </Link>
              </Col> */}
              {/* <Col xl="4" sm="6">
                <Button
                  className="btn-icon-vertical btn-square btn-transition"
                  outline
                  color="link"
                >
                  <i className="pe-7s-browser icon-gradient bg-night-fade btn-icon-wrapper btn-icon-lg mb-3">
                    {" "}
                  </i>
                  Content
                </Button>
              </Col>
              <Col xl="4" sm="6">
                <Button
                  className="btn-icon-vertical btn-square btn-transition"
                  outline
                  color="link"
                >
                  <i className="pe-7s-hourglass icon-gradient bg-night-fade btn-icon-wrapper btn-icon-lg mb-3">
                    {" "}
                  </i>
                  Activity
                </Button>
              </Col>
              <Col xl="4" sm="6">
                <Button
                  className="btn-icon-vertical btn-square btn-transition"
                  outline
                  color="link"
                >
                  <i className="pe-7s-world icon-gradient bg-night-fade btn-icon-wrapper btn-icon-lg mb-3">
                    {" "}
                  </i>
                  Contacts
                </Button>
              </Col> */}
            </Row>
          </div>
          <Nav vertical>
            <NavItem className="nav-item-divider" />
            <NavItem className="nav-item-btn text-center">
              <Button size="sm" className="btn-shadow" color="primary" onClick={handleConfigShortcuts}>
                CONFIGUREAZA OPTIUNILE RAPIDE
              </Button>
            </NavItem>
          </Nav>
        </DropdownMenu>
      </UncontrolledDropdown>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  menuItems: state.UserOptions.menuItems,
  menuItemsShortcuts: state.UserOptions.menuItemsShortcuts
})

const mapDispatchToProps = dispatch => ({
  setMenuItemsShortcuts: ms => dispatch(userActions.setMenuItemsShortcuts(ms))
})

export default connect(mapStateToProps, mapDispatchToProps)(Redirects);
